import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Button, Container } from 'reactstrap';
import PropTypes from 'prop-types';

import Page from '../../components/layout/Page';
import MainProductList from '../../components/product-list/MainProductList';
import HelperNavigation from '../../components/common/HelperNavigation';
import GenericLayout from '../../components/layout/GenericLayout';
import ProductSortOrderBy from '../../types/ProductSortOrderBy';
import SortOrder from '../../types/SortOrder';
import globalTranslations from '../../i18n/globalTranslations';
import PageTitle from '../../components/common/PageTitle';
import Paths from '../../types/Paths';
import SEOTitle from '../../components/head/SEOTitle';
import CanonicalLink from '../../components/head/CanonicalLink';
import ContentPopup from '../../components/ad/ContentPopup';
import MainBanner from '../../components/ad/MainBanner';
import ConfigStore from '../../store/ConfigStore';
import SectionStore from '../../store/SectionStore';
import RouteService from '../../services/RouteService';
import { modelOf } from '../../prop-types';
import ScrollReset from '../../components/common/ScrollReset';
import AdPages from '../../types/AdPages';
import AccountModalTab from '../../types/AccountModalTab';
import AccountModalLink from '../../components/account/AccountModalLink';
import AccountStore from '../../store/AccountStore';
import CommonPage from '../../types/CommonPage';

@observer
class CustomerProductsPage extends Component {
  getBreadcrumbsPath = () => {
    const { intl, routeService } = this.props;
    return routeService.transformBreadCrumbs([
      {
        text: intl.formatMessage(globalTranslations.customerProductsTitle),
        url: Paths.CustomerProducts
      }
    ]);
  };

  getSearchParams = () => ({
    bannerPage: AdPages.CUSTOMER_PRODUCTS
  });

  renderLogIn = () => (
    <AccountModalLink tab={AccountModalTab.LOGIN}>
      <Button tag="span" color="primary">
        <FormattedMessage {...globalTranslations.logInSentence} />
      </Button>
    </AccountModalLink>
  );

  render() {
    const listName = 'Customer Products List';
    const {
      configStore,
      sectionStore,
      routeService,
      accountStore
    } = this.props;

    const contentAllowed = accountStore.loggedIn && accountStore.isRetailer;

    const fixedParams = {
      orderBy: ProductSortOrderBy.CATEGORY,
      order: SortOrder.ASC,
      hasCustomerPrice: 1
    };
    if (sectionStore.activeSection) {
      fixedParams.sections = [sectionStore.activeSection.id];
    }

    const mainBanner = <MainBanner searchParams={this.getSearchParams()} />;
    const mainBannerWithinContent =
      configStore.mainBanner.withinContent && !configStore.mainBanner.fullWidth;

    return (
      <Page
        name={CommonPage.CUSTOMER_PRODUCTS}
        className="CustomerProductsPage"
      >
        <ScrollReset />
        <SEOTitle
          title={{
            ...globalTranslations.customerProductsTitle
          }}
        />
        <CanonicalLink path={routeService.getPath(Paths.CustomerProducts)} />
        {!mainBannerWithinContent && mainBanner}
        <Container className="CustomerProductsPage__container">
          <GenericLayout
            content={
              <Fragment>
                {mainBannerWithinContent && mainBanner}
                <HelperNavigation breadcrumbsPath={this.getBreadcrumbsPath()} />
                <PageTitle>
                  <FormattedMessage
                    {...globalTranslations.customerProductsTitle}
                  />
                </PageTitle>
                {contentAllowed && (
                  <MainProductList
                    fixedParams={fixedParams}
                    name={listName}
                    showSort={false}
                    showCategoryHeaders={true}
                  />
                )}
                {!contentAllowed &&
                  !accountStore.loggedIn &&
                  this.renderLogIn()}
                <ContentPopup searchParams={this.getSearchParams()} />
              </Fragment>
            }
          />
        </Container>
      </Page>
    );
  }
}

CustomerProductsPage.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  sectionStore: modelOf(SectionStore).isRequired,
  intl: intlShape.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired
};

export default injectIntl(
  inject('accountStore', 'configStore', 'sectionStore', 'routeService')(
    CustomerProductsPage
  )
);



// WEBPACK FOOTER //
// ./src/pages/CustomerProductsPage/index.jsx